import { connect } from 'react-redux'

import { doOpenTicketMergePage } from 'actions/pages'
import {
  doMarkAsUnread,
  doMarkAsRead,
  doCurrentMailboxChanged,
  doToggleTicketAsSpam,
  doDeleteCurrentTicket,
  doRestoreTicket,
  doFollowCurrentTicket,
  doUnfollowCurrentTicket,
  doPrintWholeTicket,
} from 'actions/tickets'

import { selectPossibleMailboxesForChange } from 'selectors/mailboxes'
import {
  selectCurrentTicketIsUnread,
  selectCurrentTicketIsSpam,
  selectCurrentTicketIsDeleted,
  selectCurrentTicketIsFollowing,
} from 'selectors/tickets'

import MainDropdown from './view'

const select = state => ({
  isDeleted: selectCurrentTicketIsDeleted(state),
  isSpam: selectCurrentTicketIsSpam(state),
  isUnread: selectCurrentTicketIsUnread(state),
  isFollowing: selectCurrentTicketIsFollowing(state),
  mailboxes: selectPossibleMailboxesForChange(state),
})

const perform = dispatch => ({
  doToggleTicketAsSpam: ticketId => dispatch(doToggleTicketAsSpam(ticketId)),
  doMarkAsRead: ticketId => dispatch(doMarkAsRead(ticketId)),
  doMarkAsUnread: ticketId => dispatch(doMarkAsUnread(ticketId)),
  doChangeMailbox: (ticketId, mailboxId) =>
    dispatch(doCurrentMailboxChanged(ticketId, mailboxId)),
  doDeleteTicket: ({ deleteMode = 'SOFT' } = {}) =>
    dispatch(doDeleteCurrentTicket(deleteMode)),
  doRestoreTicket: ticketId => dispatch(doRestoreTicket(ticketId)),
  doFollowTicket: () => dispatch(doFollowCurrentTicket()),
  doUnfollowTicket: () => dispatch(doUnfollowCurrentTicket()),
  doPrintWholeTicket: ticketId => {
    return dispatch(doPrintWholeTicket(ticketId))
  },
  doOpenTicketMergePage: ticketId => {
    return dispatch(doOpenTicketMergePage(ticketId))
  },
})

export default connect(select, perform)(MainDropdown)
